import { types, actions } from './requests'
export const CREATEUSER_TYPES = {
    ...types('CREATEUSER'),
}
export const CREATEUSER_ACTIONS = {
    ...actions('CREATEUSER'),
}
